/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LoginAliases {
  ADDRES_TEXT = 'addres-text',
  ADDRESS_PANEL = 'address-panel',
  COMPLEMENT_TEXT = 'complement-text',
  CUSTOM_LAYOUT = 'custom-layout',
  MAIN_LOGIN = 'main-login',
  SOCIAL_NETWORKS = 'social-networks',
  SOCIAL_NETWORKS_PANEL = 'social-networks-panel',
}
export { LoginAliases };
